import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import i18n from "./i18n";
import "./index.css";
import * as serviceWorker from "./serviceWorker";

i18n.init().then(() => {
	document.documentElement.lang = i18n.language;

	const container = document.getElementById("root");
	// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	const root = ReactDOM.createRoot(container!);
	root.render(
		<React.StrictMode>
			<App />
		</React.StrictMode>
	);
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
